import React from 'react';

import { TvSeriesEpisode } from '../../../forces/tvSeries/tvSeriesDetails.types';
import { CoverPageGrid } from '../grid/CoverPageGrid';

import { Episode } from './Episode';
import { MoreEpisodes } from './MoreEpisodes';

import styles from './Episode.module.css';
interface Props {
  episodes: TvSeriesEpisode[];
  selectedEpisodeId?: string;
  seasonLabel?: string | number;
  pagination: { hasMoreEpisodes: boolean; loadMoreEpisodes: () => void };
}

export const Episodes: React.FunctionComponent<Props> = ({ episodes, selectedEpisodeId, seasonLabel, pagination }) => {
  const displayedSeasonHeading =
    typeof seasonLabel === 'string' ? seasonLabel : `Viser episoder fra sesong ${seasonLabel}`;

  return (
    <div style={{ marginBottom: 'var(--rds-spacing--32)' }}>
      {seasonLabel && (
        <h3 className="sr-only" aria-live="polite">
          {displayedSeasonHeading}
        </h3>
      )}
      <CoverPageGrid>
        {episodes.map(episode => (
          <Episode key={episode.id} episode={episode} selected={selectedEpisodeId === episode.id} />
        ))}
      </CoverPageGrid>
      {pagination.hasMoreEpisodes && (
        <MoreEpisodes className={styles.tvShowEpisodesMoreEpisodesBtn} onClick={pagination.loadMoreEpisodes} />
      )}
    </div>
  );
};
